import React, {Component} from 'react';
import logo from './logo.svg';

import Form from './Form';
import DownloadImage from './DownloadImage';
class App extends Component {
    constructor(props) {
        super(props);
        this.fetchValues = this
            .fetchValues
            .bind(this);
        this.state = {
            imageURL: undefined,
            videoURL:undefined
        }
    }

    fetchValues(url) {
        fetch("https://idevs.info/?url=" + url + "&photo=true&insta=true").then((resp) => {
            return resp.json();
        }).then((obj) => {
            if (obj.videoURL){
                this.setState({ videoURL: obj.videoURL })
            }
            this.setState({ imageURL: obj.url })
            console.log(this.state.imageURL, this.state.videoURL);
        });
    }
    render() {
        return (
            <React.Fragment>
               
                <div className="app">
                    <div>
                        Download instagram images of high quality by pasting the instagram url in the
                        below box.
                    </div>
                    <Form fetchURL={this.fetchValues}/> 
                    {
                typeof this.state.imageURL!=="undefined" && <DownloadImage imageURL={this.state.imageURL} videoURL={this.state.videoURL}/>
                    }
                    </div>
                    </React.Fragment>
    )}
  }
  export default App;